import { render } from "./CourseShortCardMenuContext.vue?vue&type=template&id=0ecd51b2&scoped=true"
import script from "./CourseShortCardMenuContext.vue?vue&type=script&lang=js"
export * from "./CourseShortCardMenuContext.vue?vue&type=script&lang=js"

import "./CourseShortCardMenuContext.vue?vue&type=style&index=0&id=0ecd51b2&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecd51b2"]])

export default __exports__